import styled from '@emotion/styled';
import { Input as InputBase } from 'antd';
import { InputProps } from 'antd/lib/input';
import React from 'react';

export interface IInputProps extends InputProps {
  style?: React.CSSProperties;
}

const Input: React.FC<IInputProps> = ({ style, ...props }) => {
  return <InputBase style={style} {...props} />;
};

export default styled(Input)`
  &.ant-input {
    border-radius: 2px;
  }
`;
